import { getDate,  getHours,  getMinutes,  getMonth, getSeconds, getYear, isAfter, isBefore, isEqual, isSameDay, previousDay } from 'date-fns'
import { toZonedTime, format } from 'date-fns-tz' 

/**
* This function transform date in format establecido
@param {Date} date - date
@param {String} format - format transform date
*/
const parseDateTimezoneString = (date, pattern = 'dd/MM/yyyy', timezone) => format(toZonedTime(date, timezone),  pattern, { timeZone: timezone }).toString()
const parseDateTimezone = (date, pattern = 'dd/MM/yyyy', timezone) => date ? format(toZonedTime(date, timezone),  pattern, { timeZone: timezone }) : ''

const getInternalDatenow = (timezone, datenow) => toZonedTime(datenow || new Date(), timezone)

const returnDate = (date, type) => {
  const day = getDate(date)
  const month = getMonth(date)
  const year = getYear(date)
  const hours = getHours(date)
  const minutes = getMinutes(date)
  const seconds = getSeconds(date)
  // if (type) {
  //   if (type === 'end') {
  //     return new Date(year, month, day, 23, 59, 59)
  //   }
  // }
  
  return new Date(year, month, day, hours, minutes, seconds)
}
const isBeforeYesterday = (today, date, timezone) => {
  const yesterday = previousDay(returnDate(today, 'end'), 1)
  const max  =  toZonedTime(date, timezone) 
  return isBefore(returnDate(max, 'end'), returnDate(yesterday, 'end'))
}

const isAfterYesterday = (today, date, timezone) => {
  const yesterday = previousDay(returnDate(today, 'end'), 1)
  const max = toZonedTime(date, timezone) 
  return isAfter(returnDate(max, 'end'), returnDate(yesterday, 'end'))
}

const isBeforeToday = (today, date, timezone) => {
  const max = toZonedTime(date, timezone) 
  return isBefore(returnDate(max, 'end'), returnDate(today, 'end'))
}

const isAfterToday = (today, date, timezone) => {
  const max = toZonedTime(date, timezone) 
  return isAfter(returnDate(max, 'end'), returnDate(today, 'end'))
}

/**
 * This function deternimante status acording range dates
 @param {Date} start - start date
 @param {Date} end - end date
*/
const determinateStatusTimezone = (today, start, end, timezone) => {
  if (!start) return 'inactive'
  if (!end) return 'inactive'

  const min = toZonedTime(start, timezone) 
  const max = toZonedTime(end, timezone)


  if (isSameDay(returnDate(today), returnDate(min)) || isSameDay(returnDate(today), returnDate(max))) {
    return 'active'
  }

  return isAfter(returnDate(today), returnDate(min)) && isBefore(returnDate(today), returnDate(max)) ?  'active' : 'inactive'
}

/**
* This function generate range date for graphics
@param {Date} start
@param {Date} end
*/
const getRangeDateTimezone = (start, end, timezone) => {
  let startDate = ''
  let endDate = ''

  if (start) {
    startDate = parseDateTimezone(start, 'dd/MM/yyyy', timezone)
  }
  if (end) {
    endDate = parseDateTimezone(end, 'dd/MM/yyyy', timezone)
  }

  if (start === end) {
    endDate = ''
  }
  return `${startDate}${endDate === '' ? '' : ' - '+endDate}`
}



export {
  returnDate, isBeforeToday, isAfterToday, 
  isAfterYesterday, isBeforeYesterday,
  parseDateTimezone, determinateStatusTimezone, getRangeDateTimezone, getInternalDatenow, parseDateTimezoneString
}
  